(function () {
  var all = document.querySelectorAll('[data-mpn-fmt]');
  var box = all[all.length - 1];
  if (!box || box.dataset.ready) return;
  box.dataset.ready = '1';
  var dataEl = box.querySelector('[data-mpn-fmt-data]');
  var D = {};
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var host = box.querySelector('[data-mpn-dims-host]');
  var info = box.closest('.product__info-container') || document.querySelector('.product__info-container');
  if (info) {
    info.classList.add('mpn-fmt-on');
    /* pictos : juste après le prix, avant le texte en gras. Le choix du format reste à sa place (étape 1, avant la quantité). */
    var topOf = function (el) { while (el && el.parentElement && el.parentElement !== info) el = el.parentElement; return el && el.parentElement === info ? el : null; };
    var priceEl = info.querySelector('[id^="variant-price-summary"]');
    var descEl = info.querySelector('.bottom-border');
    var pTop = priceEl && topOf(priceEl), dTop = descEl && topOf(descEl), bTop = topOf(box);
    if (host) {
      /* Collé directement au-dessus du texte (sinon un <script> s'intercale entre pictos et texte :
         la marge du texte reste ~1 s, le temps que la mise en page finale la retire = saut au chargement). */
      var follows = function (a, b) { return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING); };
      if (dTop && dTop !== bTop && (!pTop || follows(pTop, dTop))) dTop.before(host);
      else if (pTop && pTop !== bTop) pTop.after(host);
    }
  }

  /* écart pictos : 24 px jusqu'au contenu visible au-dessus et en dessous, quel que soit le bloc voisin */
  var GAP = 24, SKIP = /^(SCRIPT|STYLE|TEMPLATE|NOSCRIPT|LINK|META)$/, SOLID = /^(IMG|SVG|INPUT|SELECT|BUTTON|TEXTAREA|VIDEO|IFRAME|HR|CANVAS|PICTURE)$/i;
  function paint(el, acc) {
    if (!el || el.nodeType !== 1 || SKIP.test(el.tagName)) return;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position === 'fixed' || cs.position === 'absolute') return;
    var r = el.getBoundingClientRect();
    if (r.height < 1 && r.width < 1 && cs.display !== 'contents') return;
    if (r.height >= 1) {
      var bt = cs.borderTopStyle !== 'none' ? parseFloat(cs.borderTopWidth) : 0, bb = cs.borderBottomStyle !== 'none' ? parseFloat(cs.borderBottomWidth) : 0;
      if (SOLID.test(el.tagName) || (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent')) { acc.push([r.top, r.bottom]); if (SOLID.test(el.tagName)) return; }
      if (bt > 0) acc.push([r.top, r.top + bt]);
      if (bb > 0) acc.push([r.bottom - bb, r.bottom]);
    }
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.replace(/\s/g, '').split(String.fromCharCode(8203)).join('') !== '') {
        var rg = document.createRange(); rg.selectNodeContents(n);
        var rr = rg.getClientRects();
        for (var k = 0; k < rr.length; k++) if (rr[k].height >= 1) acc.push([rr[k].top, rr[k].bottom]);
      } else if (n.nodeType === 1) paint(n, acc);
    }
  }
  function edge(start, dir) {
    for (var el = start; el; el = dir > 0 ? el.nextElementSibling : el.previousElementSibling) {
      var acc = []; paint(el, acc);
      if (acc.length) return dir > 0 ? Math.min.apply(null, acc.map(function (a) { return a[0]; })) : Math.max.apply(null, acc.map(function (a) { return a[1]; }));
    }
    return null;
  }
  var fitting = false;
  function fit() {
    /* Desactive (oct. 2026, demande d'Ed) : les recalculs successifs (60 ms, 0,7 s, 2 s, polices, chargement) collaient puis
       decollaient les pictos du texte en dessous, la fiche sautait. L'espace fixe de snippets/mpn-format-assets.liquid suffit. */
    return;
    if (!host || !host.parentElement || fitting) return;
    fitting = true;
    ['margin-top', 'margin-bottom', 'padding-top', 'padding-bottom'].forEach(function (k) { host.style.setProperty(k, '0px', 'important'); });
    var r = host.getBoundingClientRect();
    if (r.height > 0) {
      var up = edge(host.previousElementSibling, -1), dn = edge(host.nextElementSibling, 1);
      var nt = up === null ? GAP : GAP - (r.top - up), nb = dn === null ? GAP : GAP - (dn - r.bottom);
      host.style.setProperty(nt >= 0 ? 'padding-top' : 'margin-top', Math.round(nt) + 'px', 'important');
      host.style.setProperty(nb >= 0 ? 'padding-bottom' : 'margin-bottom', Math.round(nb) + 'px', 'important');
    }
    fitting = false;
  }
  var fitT;
  function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fit, 60); }
  if (host) {
    fitSoon(); setTimeout(fit, 700); setTimeout(fit, 2000);
    window.addEventListener('load', fit);
    window.addEventListener('resize', fitSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if (window.ResizeObserver && info) {
      var lastW = 0;
      new ResizeObserver(function (en) { var w = Math.round(en[0].contentRect.width); if (w !== lastW) { lastW = w; fitSoon(); } }).observe(info);
    }
  }
  /* étape 2 : la quantité */
  function step2() {
    if (!(D.nvar > 1)) return;
    var q = document.querySelector('.product__info-container .quantity__label');
    if (q && !q.querySelector('.mpn-step')) {
      var sp = document.createElement('span');
      sp.className = 'mpn-step'; sp.setAttribute('aria-hidden', 'true'); sp.textContent = D.compose ? '1' : '2';
      q.insertBefore(sp, q.firstChild);
    }
  }
  var sheet = box.querySelector('[data-mpn-fmt-sheet]');
  if (sheet) {
    document.querySelectorAll('body > [data-mpn-fmt-sheet]').forEach(function (o) { o.remove(); });
    document.body.appendChild(sheet);
  }
  var ids = Object.keys(D.v || {});

  /* valeur qui change d'une variante à l'autre → légèrement en gras */
  var varies = [false, false, false];
  for (var i = 0; i < 3; i++) {
    var first = null;
    ids.forEach(function (id) { var x = D.v[id].k[i] + '|' + D.v[id].s[i]; if (first === null) first = x; else if (x !== first) varies[i] = true; });
  }

  function lists() {
    var l = Array.prototype.slice.call(box.querySelectorAll('[data-mpn-fmt-list]'));
    if (sheet) l.push(sheet.querySelector('[data-mpn-fmt-list]'));
    return l.filter(Boolean);
  }

  function render(id) {
    if (D.compose) id = D.compose;
    if (id && D.pb && D.pb[String(id)]) id = D.pb[String(id)];
    var v = D.v[String(id)];
    if (!v) return;
    fitSoon();
    step2();
    setTimeout(step2, 900);
    (host || box).querySelectorAll('.mpn-dims__i').forEach(function (li, i) {
      var k = v.k[i] || '', val = v.s[i] || '', muted = false;
      if (!val && k) { if (D.hideEmpty || k === 'angles' || k === 'aspect') k = ''; else { val = D.sd; muted = true; } }
      li.classList.toggle('is-empty', !k);
      li.classList.toggle('is-muted', muted);
      li.classList.toggle('is-var', !!varies[i] && !muted);
      var use = li.querySelector('use');
      if (use) use.setAttribute('href', '#mpn-ic-' + (k || 'none'));
      var lb = li.querySelector('.mpn-dims__l [data-l]') || li.querySelector('.mpn-dims__l'); lb.textContent = k ? (D.lab[k] || '') : '';
      li.querySelector('.mpn-dims__v').textContent = val;
    });
    var note = host && host.querySelector('[data-mpn-note]');
    var nbtn = host && host.querySelector('[data-mpn-note-btn]');
    if (nbtn) nbtn.hidden = !v.nt;
    if (note) { var nt = note.querySelector('[data-mpn-note-t]') || note; nt.textContent = v.nt || ''; var nu = note.querySelector('use'); if (nu) nu.setAttribute('href', '#mpn-lay-' + (v.nl || 'libre')); note.hidden = !(v.nt && nbtn && nbtn.getAttribute('aria-expanded') === 'true'); }
    lists().forEach(function (l) {
      l.querySelectorAll('.mpn-fmt__row').forEach(function (b) {
        var on = b.getAttribute('data-vid') === String(id);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    var lv = box.querySelector('[data-mpn-fmt-val]');
    if (lv) {
      lv.textContent = v.n;
      var lp = box.querySelector('[data-mpn-fmt-pr]'); if (lp) { lp.textContent = v.p || ''; if (v.po && v.p && v.po !== v.p) { var nb = document.createElement('b'); nb.className = 'mpn-now'; nb.textContent = v.p; var os = document.createElement('s'); os.textContent = v.po; lp.textContent = ''; lp.appendChild(nb); lp.appendChild(document.createTextNode(' ')); lp.appendChild(os); } }
      var ls = box.querySelector('[data-mpn-fmt-sub]'); if (ls) ls.textContent = (v.rk === 'libre' || (D.multi > 1 && v.rk !== 'fixe')) ? v.r : '';
      /* prix palette : « −10 % à la palette » sous le prix du format choisi (vide si ce format n'a pas de palette) */
      var lpal = box.querySelector('[data-mpn-fmt-pal]'); if (lpal) { lpal.textContent = v.pal || ''; lpal.hidden = !v.pal; }
    }
  }

  function currentId() {
    var id = null;
    if (typeof window.mpnMainVariantId === 'function') { var x = window.mpnMainVariantId(); if (x) id = String(x); }
    if (!id) { var inp = document.querySelector('form[id^="product-form-"] input[name="id"]'); id = inp ? String(inp.value) : null; }
    /* prix palette : la variante palette s'affiche comme son format au m² (snippets/mpn-palette.liquid) */
    if (id && D.pb && D.pb[id]) id = String(D.pb[id]);
    return id;
  }

  function choose(id) {
    var v = D.v[String(id)];
    if (!v) return;
    var vs = document.querySelector('.product__info-container variant-selects') || document.querySelector('variant-selects');
    var done = false;
    if (vs && v.o) {
      var sels = vs.querySelectorAll('select');
      if (sels.length) {
        sels.forEach(function (sel, i) { if (v.o[i] != null) sel.value = v.o[i]; });
        sels[sels.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
        done = true;
      } else {
        v.o.forEach(function (val, i) {
          var fs = vs.querySelectorAll('fieldset')[i];
          if (!fs) return;
          fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
            if (r.value === val && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); done = true; }
          });
        });
      }
    }
    if (!done) { var u = new URL(location.href); u.searchParams.set('variant', id); location.href = u.toString(); return; }
    render(id);
    closeSheet();
  }

  function openSheet() {
    if (!sheet) return;
    sheet.hidden = false;
    document.documentElement.classList.add('mpn-fmt-lock');
    var on = sheet.querySelector('.mpn-fmt__row.is-on');
    if (on && on.scrollIntoView) on.scrollIntoView({ block: 'center' });
    var x = sheet.querySelector('.mpn-fmt-sheet__x'); if (x) x.focus({ preventScroll: true });
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('mpn-fmt-lock');
  }

  function onClick(e) {
    var row = e.target.closest('.mpn-fmt__row');
    if (row) { e.preventDefault(); choose(row.getAttribute('data-vid')); return; }
    var tip = e.target.closest('[data-mpn-tip]');
    if (tip) {
      var p = tip.closest('.mpn-fmt__sec').querySelector('.mpn-fmt__tip');
      var open = tip.getAttribute('aria-expanded') === 'true';
      tip.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (p) p.hidden = open;
      return;
    }
    if (e.target.closest('[data-mpn-fmt-open]')) { openSheet(); return; }
    if (e.target.closest('[data-mpn-fmt-close]')) { closeSheet(); }
  }
  box.addEventListener('click', onClick);
  /* « i » de la longueur libre : ouvre / ferme l'explication sous les pictos */
  if (host) host.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mpn-note-btn]'); if (!b) return;
    var n = host.querySelector('[data-mpn-note]'), open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open ? 'true' : 'false'); if (n) n.hidden = !open; fitSoon();
  });
  /* panneau des formats : se ferme aussi en glissant vers le bas (mobile) */
  var pnl = sheet && sheet.querySelector('.mpn-fmt-sheet__p'), sy = null, sdy = 0, st0 = 0;
  if (pnl) {
    pnl.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750) return;
      var body = pnl.querySelector('.mpn-fmt-sheet__b');
      if (body && body.contains(e.target) && body.scrollTop > 0) { sy = null; return; }
      sy = e.touches[0].clientY; sdy = 0; st0 = Date.now(); pnl.style.transition = 'none';
    }, { passive: true });
    pnl.addEventListener('touchmove', function (e) {
      if (sy === null) return;
      sdy = e.touches[0].clientY - sy;
      if (sdy > 0) { pnl.style.transform = 'translateY(' + sdy + 'px)'; if (e.cancelable) e.preventDefault(); }
      else { pnl.style.transform = ''; }
    }, { passive: false });
    pnl.addEventListener('touchend', function () {
      if (sy === null) return;
      var fast = sdy > 40 && sdy / Math.max(1, Date.now() - st0) > 0.5;
      pnl.style.transition = 'transform .2s ease';
      if (sdy > 90 || fast) { pnl.style.transform = 'translateY(100%)'; setTimeout(function () { closeSheet(); pnl.style.transform = ''; pnl.style.transition = ''; }, 180); }
      else { pnl.style.transform = ''; }
      sy = null;
    });
  }
  if (sheet) sheet.addEventListener('click', onClick);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id' && e.target.closest('form[id^="product-form-"]')) render(e.target.value);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) { try { render(ev.data.variant.id); } catch (err) {} });
  }
  function init() {
    var cid = currentId();
    /* parcours carreau central + bordure : la variante achetée en étape 1 est toujours le carreau central */
    if (D.compose && cid && cid !== String(D.compose)) choose(D.compose);
    render(cid || ids[0]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
